// import React from 'react';
// import { Edit2, Key, TabletSmartphone, Fingerprint, Trash2 } from 'lucide-react';

// const UserTable = ({
//   users,
//   selectedIds,
//   allFilteredSelected,
//   onToggleSelectAll,
//   onToggleSelectUser,
//   onUserClick,
//   onUpdateClick,
//   onDeleteClick,
//   onEnrollClick,
//   onEnrollToDeviceClick,
//   onSetPasswordClick,
//   userRole,
//   getStatusBadge
// }) => {
//   return (
//     <div className="overflow-y-auto overflow-x-auto max-h-[500px] rounded-xl">
//       <table className="w-full text-left border-collapse">
//         <thead className="sticky top-0 z-10 bg-richblue-950">
//           <tr className="border-b border-blue-800/60">
//             <th className="w-10 p-3">
//               <input
//                 type="checkbox"
//                 checked={allFilteredSelected}
//                 onChange={onToggleSelectAll}
//                 className="w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//               />
//             </th>
//             <th className="p-3 font-semibold text-blue-300">User</th>
//             <th className="p-3 font-semibold text-blue-300">Manager</th>
//             <th className="p-3 font-semibold text-blue-300">Department</th>
//             <th className="p-3 font-semibold text-blue-300">ID</th>
//             <th className="p-3 font-semibold text-blue-300">Enroll ID</th>
//             <th className="p-3 font-semibold text-blue-300">Status</th>
//             <th className="p-3 font-semibold text-blue-300">Devices</th>
//             <th className="p-3 font-semibold text-blue-300">Actions</th>
//           </tr>
//         </thead>
//         <tbody className="divide-y divide-blue-900/50">
//           {[...users].sort((a, b) => a.user_name?.localeCompare(b.user_name)).map((user) => {
//             const isSelected = selectedIds.includes(user._id);
//             return (
//               <tr
//                 key={user._id}
//                 className={`transition-colors cursor-pointer hover:bg-blue-950/30 ${isSelected ? 'bg-red-900/10' : ''}`}
//                 onClick={() => onUserClick(user)}
//               >
//                 <td className="p-3" onClick={(e) => e.stopPropagation()}>
//                   <input
//                     type="checkbox"
//                     checked={isSelected}
//                     onChange={(e) => onToggleSelectUser(e, user._id)}
//                     className="w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//                   />
//                 </td>
//                 <td className="p-3">
//                   <div className="flex items-center gap-3 whitespace-nowrap">
//                     <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 font-bold text-white border rounded-full bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30 ${isSelected ? 'ring-2 ring-red-500/60' : ''}`}>
//                       {user.user_name?.charAt(0)}
//                     </div>
//                     <span className="font-medium text-white">{user.user_name}</span>
//                   </div>
//                 </td>
//                 <td className="p-3 text-blue-300/80 whitespace-nowrap">{user.manager_Id?.manager_name || 'N/A'}</td>
//                 <td className="p-3 text-white whitespace-nowrap">{user.user_department}</td>
//                 <td className="p-3 font-mono text-sm text-gray-400 whitespace-nowrap">{user.user_roll}</td>
//                 {/* <td className="p-3 font-mono text-sm text-gray-400 whitespace-pre-line">
//                   {user.devices
//                     .map(d => `${d.device?.device_name ?? "-"} - ${d.enrollment_id ?? "-"}`)
//                     .join("\n")}
//                 </td> */}
//                 <td className="p-3 font-mono text-sm text-gray-400">
//                   {user.devices?.length ? (
//                     user.devices.map((d, index) => (
//                       <div key={index} className="whitespace-nowrap">
//                         {d.device?.device_name ?? "-"} - {d.enrollment_id ?? "-"}
//                       </div>
//                     ))
//                   ) : (
//                     "-"
//                   )}
//                 </td>
//                 <td className="p-3">
//                   <span className={`px-3 py-1 rounded-full text-xs font-semibold capitalize whitespace-nowrap ${getStatusBadge(user.status)}`}>
//                     {user.status}
//                   </span>
//                 </td>
//                 <td className="p-3">
//                   <span className="px-2 py-1 text-xs text-blue-300 rounded-lg bg-blue-600/20 whitespace-nowrap">
//                     {user.devices?.length || 0} device(s)
//                   </span>
//                 </td>
//                 <td className="p-3" onClick={(e) => e.stopPropagation()}>
//                   <div className="flex items-center gap-2">
//                     <button
//                       onClick={(e) => onUpdateClick(e, user)}
//                       className="p-2 transition-colors rounded-lg bg-yellow-600/20 hover:bg-yellow-600/40"
//                       title="Edit"
//                     >
//                       <Edit2 className="w-4 h-4 text-yellow-400" />
//                     </button>
//                     {userRole === 'Manager' && (
//                       <button
//                         onClick={(e) => onSetPasswordClick(e, user)}
//                         className="p-2 transition-colors rounded-lg bg-blue-600/20 hover:bg-blue-600/40"
//                         title="Set Password"
//                       >
//                         <Key className="w-4 h-4 text-blue-200" />
//                       </button>
//                     )}
//                     <button
//                       onClick={(e) => onEnrollClick(e, user)}
//                       className="p-2 transition-colors rounded-lg bg-green-600/20 hover:bg-green-600/40"
//                       title="Enroll"
//                     >
//                       <TabletSmartphone className="w-4 h-4 text-green-400" />
//                     </button>
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         onEnrollToDeviceClick(e, user);
//                       }}
//                       className="p-2 transition-colors rounded-lg bg-purple-600/20 hover:bg-purple-600/40"
//                       title="Import Fingerprint"
//                     >
//                       <Fingerprint className="w-4 h-4 text-purple-400" />
//                     </button>
//                     <button
//                       onClick={(e) => onDeleteClick(user, null, 'DeleteUser', e)}
//                       className="p-2 transition-colors rounded-lg bg-red-600/20 hover:bg-red-600/40"
//                       title="Delete"
//                     >
//                       <Trash2 className="w-4 h-4 text-red-400" />
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default UserTable;



import React from 'react';
import { Edit2, Key, TabletSmartphone, Fingerprint, Trash2 } from 'lucide-react';

const UserTable = ({
  users,
  selectedIds,
  allFilteredSelected,
  onToggleSelectAll,
  onToggleSelectUser,
  onUserClick,
  onUpdateClick,
  onDeleteClick,
  onEnrollClick,
  onEnrollToDeviceClick,
  onSetPasswordClick,
  userRole,
  getStatusBadge,
  theme
}) => {
  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgHeader = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  const bgTable = isDark ? 'bg-richblue-800/20' : 'bg-white';
  const bgRowHover = isDark ? 'hover:bg-blue-950/30' : 'hover:bg-gray-100/50';
  const bgRowSelected = isDark ? 'bg-red-900/10' : 'bg-red-50';
  
  const borderHeader = isDark ? 'border-blue-800/60' : 'border-gray-300';
  const borderRow = isDark ? 'divide-blue-900/50' : 'divide-gray-200';
  
  const textHeader = isDark ? 'text-blue-300' : 'text-gray-700';
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-blue-300/80' : 'text-gray-600';
  const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  
  const checkboxStyles = isDark 
    ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50'
    : 'text-red-500 border-gray-300 bg-white focus:ring-red-500';
  
  const badgeBg = isDark ? 'bg-blue-600/20 text-blue-300' : 'bg-blue-100/20 text-blue-700';
  const avatarBg = isDark 
    ? 'bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30'
    : 'bg-gradient-to-br from-blue-500 to-blue-700 border-blue-400';
  
  const ringSelected = isDark ? 'ring-2 ring-red-500/60' : 'ring-2 ring-red-400';

  // Button styles
  const editBtn = isDark
    ? 'bg-yellow-600/20 hover:bg-yellow-600/40 text-yellow-400'
    : 'bg-yellow-100/30 hover:bg-yellow-200/20 text-yellow-600';
  
  const passwordBtn = isDark
    ? 'bg-blue-600/20 hover:bg-blue-600/40 text-blue-200'
    : 'bg-blue-100/20 hover:bg-blue-200/30 text-blue-600';
  
  const enrollBtn = isDark
    ? 'bg-green-600/20 hover:bg-green-600/40 text-green-400'
    : 'bg-green-100 hover:bg-green-200 text-green-600';
  
  const templateBtn = isDark
    ? 'bg-purple-600/20 hover:bg-purple-600/40 text-purple-400'
    : 'bg-purple-100 hover:bg-purple-200 text-purple-600';
  
  const deleteBtn = isDark
    ? 'bg-red-600/20 hover:bg-red-600/40 text-red-400'
    : 'bg-red-100 hover:bg-red-200 text-red-600';

  return (
    <div className={`overflow-y-auto overflow-x-auto max-h-[500px] rounded-xl ${bgTable} transition-colors duration-300`}>
      <table className="w-full text-left border-collapse">
        <thead className={`sticky top-0 z-10 ${bgHeader} transition-colors duration-300`}>
          <tr className={`border-b ${borderHeader}`}>
            <th className="w-10 p-3">
              <input
                type="checkbox"
                checked={allFilteredSelected}
                onChange={onToggleSelectAll}
                className={`w-4 h-4 rounded cursor-pointer ${checkboxStyles}`}
              />
            </th>
            <th className={`p-3 font-semibold ${textHeader}`}>User</th>
            <th className={`p-3 font-semibold ${textHeader}`}>Manager</th>
            <th className={`p-3 font-semibold ${textHeader}`}>Department</th>
            <th className={`p-3 font-semibold ${textHeader}`}>ID</th>
            <th className={`p-3 font-semibold ${textHeader}`}>Enroll ID</th>
            <th className={`p-3 font-semibold ${textHeader}`}>Status</th>
            <th className={`p-3 font-semibold ${textHeader}`}>Devices</th>
            <th className={`p-3 font-semibold ${textHeader}`}>Actions</th>
          </tr>
        </thead>
        <tbody className={`divide-y ${borderRow}`}>
          {[...users].sort((a, b) => a.user_name?.localeCompare(b.user_name)).map((user) => {
            const isSelected = selectedIds.includes(user._id);
            return (
              <tr
                key={user._id}
                className={`transition-colors cursor-pointer ${bgRowHover} ${isSelected ? bgRowSelected : ''}`}
                onClick={() => onUserClick(user)}
              >
                <td className="p-3" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => onToggleSelectUser(e, user._id)}
                    className={`w-4 h-4 rounded cursor-pointer ${checkboxStyles}`}
                  />
                </td>
                <td className="p-3">
                  <div className="flex items-center gap-3 whitespace-nowrap">
                    <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 font-bold text-white border rounded-full ${avatarBg} ${isSelected ? ringSelected : ''}`}>
                      {user.user_name?.charAt(0)}
                    </div>
                    <span className={`font-medium ${textPrimary}`}>{user.user_name}</span>
                  </div>
                </td>
                <td className={`p-3 ${textSecondary} whitespace-nowrap`}>{user.manager_Id?.manager_name || 'N/A'}</td>
                <td className={`p-3 ${textPrimary} whitespace-nowrap`}>{user.user_department}</td>
                <td className={`p-3 font-mono text-sm ${textMuted} whitespace-nowrap`}>{user.user_roll}</td>
                <td className={`p-3 font-mono text-sm ${textMuted}`}>
                  {user.devices?.length ? (
                    user.devices.map((d, index) => (
                      <div key={index} className="whitespace-nowrap">
                        {d.device?.device_name ?? "-"} - {d.enrollment_id ?? "-"}
                      </div>
                    ))
                  ) : (
                    "-"
                  )}
                </td>
                <td className="p-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold capitalize whitespace-nowrap ${getStatusBadge(user.status)}`}>
                    {user.status}
                  </span>
                </td>
                <td className="p-3">
                  <span className={`px-2 py-1 text-xs rounded-lg whitespace-nowrap ${badgeBg}`}>
                    {user.devices?.length || 0} device(s)
                  </span>
                </td>
                <td className="p-3" onClick={(e) => e.stopPropagation()}>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={(e) => onUpdateClick(e, user)}
                      className={`p-2 transition-colors rounded-lg ${editBtn}`}
                      title="Edit"
                    >
                      <Edit2 className="w-4 h-4" />
                    </button>
                    {userRole === 'Manager' && (
                      <button
                        onClick={(e) => onSetPasswordClick(e, user)}
                        className={`p-2 transition-colors rounded-lg ${passwordBtn}`}
                        title="Set Password"
                      >
                        <Key className="w-4 h-4" />
                      </button>
                    )}
                    <button
                      onClick={(e) => onEnrollClick(e, user)}
                      className={`p-2 transition-colors rounded-lg ${enrollBtn}`}
                      title="Enroll"
                    >
                      <TabletSmartphone className="w-4 h-4" />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onEnrollToDeviceClick(e, user);
                      }}
                      className={`p-2 transition-colors rounded-lg ${templateBtn}`}
                      title="Import Fingerprint"
                    >
                      <Fingerprint className="w-4 h-4" />
                    </button>
                    <button
                      onClick={(e) => onDeleteClick(user, null, 'DeleteUser', e)}
                      className={`p-2 transition-colors rounded-lg ${deleteBtn}`}
                      title="Delete"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;